import React from "react";
import Button from "../../atoms/Button";
import Registries from "../FilterDialogBox/Registry";
import DiaglogBox from "../../atoms/DiaglogBox";
import FilterToken from "./FilterToken";
import Category from "./Category";
import CountrySelect from "./Country";
import Status from "./Status";

const FilterBox = ({
  open,
  onOk,
  onCancel,
  page,
  selectedRegistry,
  setSelectedRegistry,
  onCheckRegistry,
  selectedCategory,
  onSelectCategory,
  selectedToken,
  onSelectToken,
  selectedStatus,
  onSelectedStatus,
  selectedCountry,
  onSelectedCountry,
}) => {
  const renderFilters = () => {
    switch (page) {
      case "projects":
        return (
          <>
            <div className="flex">
              <div className="flex w-1/2 flex-col">
                <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                  Category
                </h2>
                <Category
                  selectedCategory={selectedCategory}
                  onSelectCategory={onSelectCategory}
                />
              </div>
              <div className="flex w-1/2 flex-col">
                <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                  Location
                </h2>
                <CountrySelect
                  selectedCountry={selectedCountry}
                  onSelectedCountry={onSelectedCountry}
                />
              </div>
            </div>
            <hr />
            <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
              Status
            </h2>
            <Status
              selectedStatus={selectedStatus}
              onSelectedStatus={onSelectedStatus}
            />
            <hr />
          </>
        );
      case "holdings":
      case "request":
        return (
          <>
            <div className="flex">
              <div className="flex w-1/2 flex-col">
                <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                  Category
                </h2>
                <Category
                  selectedCategory={selectedCategory}
                  onSelectCategory={onSelectCategory}
                />
              </div>
              <div className="flex w-1/2 ml-6 flex-col">
                <h2 className="py-4  ml-3 text-xs font-normal  text-grey-700">
                  Token Type
                </h2>
                <FilterToken
                  selectedToken={selectedToken}
                  onSelectToken={onSelectToken}
                />
              </div>
            </div>
            <hr />
          </>
        );
      case "bids":
        return (
          <>
            <h2 className="py-4  ml-3 text-xs font-normal  text-grey-700">
              Token Type
            </h2>
            <FilterToken
              selectedToken={selectedToken}
              onSelectToken={onSelectToken}
            />
            <hr />
          </>
        );
      case "retirements":
        return (
          <>
            <div className="flex w-1/2 flex-col">
              <h2 className="py-4 ml-3 text-xs font-normal text-grey-700">
                Category
              </h2>
              <Category
                selectedCategory={selectedCategory}
                onSelectCategory={onSelectCategory}
              />
            </div>
            <hr />
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div>
        <DiaglogBox open={open} onCancel={onCancel} width={617}>
          <div className="max-h-[410px] overflow-hidden overflow-y-scroll px-6 no-scrollbar">
            <h1 className=" text-[1.75rem] ml-3 pb-2 mt-4 font-bold text-black">
              Filter
            </h1>
            <hr />
            <h1 className="py-2  ml-3 text-xs font-normal text-grey-700">
              Registries
            </h1>
            <Registries
              selectedRegistry={selectedRegistry}
              setSelectedRegistry={setSelectedRegistry}
              onCheckRegistry={onCheckRegistry}
            />
            <hr />
            {renderFilters()}
            <div className="flex px-2 mb-7 mt-4 ">
              <Button
                varient="primary"
                borderColor="black"
                color="blue"
                className="w-1/2 h-11 text-sm justify-center mr-4 px-6 py-2 text-white font-bold"
                onClick={onOk}
              >
                Submit
              </Button>
              <Button
                varient="primary"
                className="w-1/2  h-11 text-sm font-bold justify-center px-6 py-2  text-blue-800  bg-blue-250  "
                onClick={onCancel}
              >
                Cancel
              </Button>
            </div>
          </div>
        </DiaglogBox>
      </div>
    </>
  );
};

export default FilterBox;
